import BaseApiInstance from './base';
const BASE_URL = '/coupons';

export const getCouponsApi = async params => {
  const response = await BaseApiInstance.get(`${BASE_URL}`, {
    params,
  });
  return response;
};

export const createCouponApi = async data => {
  const response = await BaseApiInstance.post(`${BASE_URL}`, data);
  return response;
};

export const updateCouponApi = async (id, data) => {
  const response = await BaseApiInstance.patch(`${BASE_URL}/${id}`, data);
  return response;
};

export const deleteCouponApi = async id => {
  const response = await BaseApiInstance.delete(`${BASE_URL}/${id}`);
  return response;
};
